<template>
    <v-form class="mb-6" @submit.prevent="() => {}" ref="form">
        <v-row class="ma-0">
            <div class="ml-4">
                <v-row class="ma-0">
                    <v-checkbox
                        v-model="value.onlyForServices"
                        label="Отправлять только по выбранным услугам"
                        class="mt-0"
                    ></v-checkbox>
                </v-row>
                <v-row class="ma-0" align="center">
                    <CustomActivatorSelect
                        class="service__input ml-0"
                        v-model="currentServiceIds"
                        :items="serviceList"
                        :multiple="true"
                        :loading="serviceLoading"
                    >
                        <template v-slot:activator="{ selected, _id }">
                            <BaseInputOutlined
                                label="Услуга"
                                hide-details
                                class="select-input"
                                append-icon="mdi-menu-down"
                                :id="_id"
                                :value="selected ? selected.name : ''"
                                readonly
                            >
                            </BaseInputOutlined>
                        </template>
                    </CustomActivatorSelect>
                </v-row>
                <div class="message-parts-editor mt-3">
                    <div class="service" v-for="service in includedServiceList" :key="service.id">
                        <span class="service-name" :title="service.name">{{ service.name || 'Загрузка...' }}</span>
                        <div class="fake-editor" style="width: 100%">
                            <div class="message-editor">
                                <div class="message-editor__header">
                                    <div class="message-editor__header__tabs" background-color="transparent">
                                        <div
                                            class="message-editor__header__tab"
                                            style="cursor: default"
                                        >
                                            Инструкции для услуги
                                        </div>
                                    </div>
                                    <div class="message-editor__header__buttons">
                                        <v-btn icon title="Копировать текст" @click="copyServiceText(service)">
                                            <v-icon small>mdi-content-copy</v-icon></v-btn
                                        >
                                    </div>
                                </div>
                                <div class="message-editor__body">
                                    <v-textarea
                                        :auto-grow="true"
                                        background-color="#f6f7f7"
                                        flat
                                        color="#2A3B51DE"
                                        solo
                                        :rows="1"
                                        no-resize
                                        hide-details
                                        v-model="service.text"
                                        class="message-text"
                                        placeholder="Введите текст"
                                    >
                                    </v-textarea>
                                </div>
                            </div>
                        </div>
                        <v-btn class="mt-2" icon @click="deleteService(service.id)">
                            <v-icon>mdi-delete-outline</v-icon></v-btn
                        >
                    </div>
                </div>
            </div>
        </v-row>
    </v-form>
</template>
<script>
import { defineComponent, ref, computed, watch, getCurrentInstance, onMounted } from 'vue'
import { getServiceListWithRecoding } from '@api/chisai/GCB2'
import useRouter from '../../../../../hooks/useRouter'
import { v4 as uuidv4 } from 'uuid'
import difference from 'lodash/difference'
import BaseInputOutlined from '../../../../inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '../../../../inputs/CustomActivatorSelect.vue'
import { onBeforeMount } from 'vue'
import AdvancedMessageEditor from '@root/src/components/ui/AdvancedMessageEditor.vue'

export default defineComponent({
    name: 'InstructionsStep',
    components: { BaseInputOutlined, CustomActivatorSelect, AdvancedMessageEditor },
    props: {
        value: { type: Object, required: true },
    },
    setup(props, { emit }) {
        const root = getCurrentInstance().proxy
        const serviceLoading = ref(false)
        const { route } = useRouter(root)
        const project = computed(() => root.$store.getters.projectById(route.value.params.id))
        const triggerValue = ref(props.value)

        const currentServiceIds = ref([])
        const serviceMap = ref({})
        const serviceList = ref([])
        const includedServiceList = ref([])
        const activeMessageVarId = ref('{name}')
        const clear = () => {
            currentServiceIds.value = []
        }
        const instructionsList = ref(props.value.instructions)
        const copyServiceText = (service) => {
            if (!service) return
            try {
                navigator.clipboard.writeText(service.text || '')
                root.$store.dispatch('callNotify', 'Текст скопирован')
            } catch (e) {}
        }
        const deleteService = (id) => {
            currentServiceIds.value = currentServiceIds.value.filter(el => el !== id)
        }
        const updateTrigger = () => {
            triggerValue.value.instructions = includedServiceList.value?.map(el => {
                return { id: el.id, text: el.text }
            })
            emit('update-trigger', triggerValue.value)
        }
        watch(
            () => currentServiceIds.value,
            (newValue, oldValue) => {
                if(serviceLoading.value) return
                const diffDel = difference(oldValue, newValue)
                const diffAdd = difference(newValue, oldValue)
                if(oldValue.length > newValue.length) {
                    includedServiceList.value = includedServiceList.value.filter(el => !diffDel.includes(el.id))
                } else if (oldValue.length < newValue.length) {
                    includedServiceList.value?.push(...diffAdd.map(i => {
                        const selectedService = serviceList.value.find(el => el.id === i)
                        if (selectedService) {
                            return {
                                id: selectedService?.id,
                                name: selectedService?.name,
                                text: '',
                            }
                        }                        
                    }))
                } else return
            },
            { deep: true}
        )
        watch(
            () => includedServiceList.value,
            v => {
                if(serviceLoading.value) return
                updateTrigger()
            },
            { deep: true, immediate: true }
        )
        watch(
            () => serviceMap.value,
            v => {
                if(serviceLoading.value) return
                includedServiceList.value = includedServiceList.value?.map(service => {
                    if (serviceMap.value[service.id]) {
                        service.name = serviceMap.value[service.id]
                    }
                    return service
                })
            },
            { deep: true, immediate: true }
        )
        onBeforeMount(async () => {
            serviceLoading.value = true
            const res = await getServiceListWithRecoding({ projectId: project.value.id }).then(d => d.data)
            serviceList.value = res
            serviceMap.value = serviceList.value?.reduce((map, service) => {
                map[service.id] = service.name
                return map
            }, {})
            serviceLoading.value = false
        })
        onMounted(() => {
            if (props.value.instructions) {
                includedServiceList.value = instructionsList.value || []
                currentServiceIds.value = (instructionsList.value || []).map(el => el.id)
            }
        })

        return {
            clear,
            activeMessageVarId,
            serviceList,
            includedServiceList,
            deleteService,
            currentServiceIds,
            serviceMap,
            instructionsList,
            updateTrigger,
            serviceLoading,
            copyServiceText
        }
    },
})
</script>
<style lang="sass" scoped>
@import '@/vars.sass'
::v-deep .v-input__append-outer
    margin-top: 9px
::v-deep .v-input__prepend-inner
    margin-top: 9px
.message-parts-slider-title
    color: $gray
    font-size: 12px
    line-height: 16px
    font-weight: $font-weight-medium
    letter-spacing: 1.07px
.slider-part
    display: flex
    align-items: center
    cursor: pointer
    width: 249px
    height: 40px
    border-left: 4px solid $gray-2
    &.active
        border-left: 4px solid $main
    &.disabled
        opacity: 0.5
        pointer-events: none
.slider-part-text
    margin-left: 8px
    color: $gray
    &.active
        color: $text-color
.message-parts-editor
    position: relative
    width: 100%
    min-height: 350px
    max-height: 500px
    border: 1px solid $light-gray-4
    border-radius: 4px
    overflow-y: visible
    overflow-x: hidden
    &::after
        display: block
        content: ''
        position: sticky
        bottom: -1px
        left: 0
        right: 0
        height: 36px
        width: 930px
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffffc9)
        margin-top: -24px
        pointer-events: none
*
    scrollbar-width: auto
    scrollbar-color: $light-gray #ffffff

*::-webkit-scrollbar
    width: 14px
*::-webkit-scrollbar-track
    background: #ffffff

*::-webkit-scrollbar-thumb
    background-color: $light-gray
    border-radius: 8px
    border: 3px solid #ffffff
*::-webkit-scrollbar-thumb:hover
    background-color: $light-gray-2


.service
    display: flex
    align-items: flex-start
    flex-direction: row
    width:100%
    &__input
        margin: 12px
        flex-grow: 0.5
    &:last-child
        margin-bottom: 12px
.service-name
    margin: 12px
    display: block
    padding: 8px 12px
    width: 440px
    border-radius: 4px
    border: 1px solid #e0e0e0
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
.message-editor
    margin-top: 12px
    border-radius: 4px
    border: 1px solid $light-gray-2
    background-color: $light-gray-5
    margin-bottom: 12px !important
    &.focused
        border: 1px solid $main
    &__body
        padding: 12px
    &__header
        padding-left: 12px
        padding-right: 12px
        padding-top: 6px
        padding-bottom: 6px
        display: flex
        justify-content: space-between
        border-bottom: 1px solid $light-gray-2
        &__tabs
            display: flex
            align-items: center
            justify-content: space-between
            width: 100%
            &__tab
                padding: 8px
                cursor: pointer
                &.active
                    border-bottom: 2px solid $main
                &.disabled
                    opacity: 0.5
                    pointer-events: none
    ::v-deep .v-input .v-input__control .v-input__slot
        padding: 0 !important
::v-deep .v-tab
    font-size: 12px !important
.editor-message
    color: $gray
    cursor: pointer
    display: flex
    justify-content: space-between
    margin-bottom: 5px
.editor-content-viewer
    background-color: transparent !important
    white-space: pre-wrap
    &:focus
        outline: none

.message-text
    background-color: $light-gray-5
    word-break: break-word
    font-size: 12px
    line-height: 1rem !important
    width: 100%
    height: 100%
::v-deep textarea
    line-height: 1rem !important
    color: #2A3B51DE !important
    margin-top: 0 !important
.placeholder
    opacity: 0.6
</style>